// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__mKJdE","btn":"pagination_btn__mR12K","icon":"pagination_icon__LPZ0i"};